import React, { lazy } from 'react';
import { AuthGuard } from '@nsd/fe';
import { AccountBalance as AccountBalanceIcon, History } from '@material-ui/icons';
import TopBarAddOn from 'src/components/TopBarAddOn';
import appIcon from './images/appIcon.png';
import DashboardLayout from 'src/layouts/DashboardLayout';

const MODULE = {
  REMITTANCE: 'dealerRemittance-1890428a-ddea-4cae-86f3-d71d08a2736f',
};

const appConfig = {
  appId: 'billing-d31c8d76-1ef5-4fa2-8852-98471db3309e',
  appName: 'Billing',
  titleKey: 'billing',
  path: 'billing',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: 'remittance',
      view: lazy(() => import('src/views/billing/RemittanceView')),
      module: MODULE.REMITTANCE
    },
    {
      exact: true,
      path: 'remittanceHistory',
      view: lazy(() => import('src/views/billing/remittanceHistory')),
      module: MODULE.REMITTANCE
    },
    {
      exact: true,
      path: 'billing',
      redirect: 'remittance'
    }
  ],
  topBarConfig: {
    dataContextOptions: {
      enableDataContextOverride: true,
      customJSX: <TopBarAddOn />
    },
    contacts: false,
    search: false,
    notifications: true,
    settings: true
  },
  navConfig: {
    navBarItems: [
      {
        subheader: 'Contracts',
        items: [
          {
            title: 'Dealer Remittance',
            icon: AccountBalanceIcon,
            href: 'remittance',
            module: MODULE.REMITTANCE
          },
          {
            title: 'Remittance History',
            icon: History,
            href: 'remittanceHistory',
            module: MODULE.REMITTANCE
          }
        ]
      }
    ]
  }
};

export default appConfig;
